import { createAsyncAction } from "../helpers";

export const getCommunityLeadersAsyncAction = createAsyncAction(
	"GET_COMMUNITY_LEADERS"
);

export const getCommunityLeadersStatsAsyncAction = createAsyncAction(
	"GET_COMMUNITY_LEADERS_STATISTICS"
);

export const getCommunityLeadersRegionsAsyncAction = createAsyncAction(
	"GET_COMMUNITY_LEADERS_REGIONS"
);

export const getCommunityLeaderAsyncAction = createAsyncAction(
	"GET_COMMUNITY_LEADER"
);

export const updateCommunityLeaderStatusAsyncAction = createAsyncAction(
	"UPDATE_COMMUNITY_LEADER_STATUS"
);

export const exportCommunityLeaderDataAsyncAction = createAsyncAction(
	"EXPORT_COMMUNITY_LEADERS"
);

export const exportCommunityLeaderRegionAsyncAction = createAsyncAction(
	"EXPORT_COMMUNITY_LEADERS_REGION"
);

export const exportCommunityLeaderMembersAndEventsAsyncAction = createAsyncAction(
	"EXPORT_COMMUNITY_LEADERS_MEMBERS_AND_EVENTS"
);
